meedy.directive('availabilityAtLeastOne', [
    function() {
        var definition = {
            restrict: 'A',
            require: 'ngModel',
            link: function($scope, element, attr, ngModelCtrl) {
                ngModelCtrl.$validators.availabilityAtLeastOne = function (modelValue, viewValue) {
                    if(modelValue) {
                        return isValid(modelValue);
                    }
                };
                $scope.$watch(function () {
                    if(ngModelCtrl.$modelValue) {
                        return isValid(ngModelCtrl.$modelValue);
                    }
                }, function () {
                    if(ngModelCtrl.$modelValue) {
                        ngModelCtrl.$validate();
                    }
                });

                function isValid (modelValue) {
                    return !!(modelValue.monday.dayDefinitions.length
                    || modelValue.tuesday.dayDefinitions.length
                    || modelValue.wednesday.dayDefinitions.length
                    || modelValue.thursday.dayDefinitions.length
                    || modelValue.friday.dayDefinitions.length
                    || modelValue.saturday.dayDefinitions.length
                    || modelValue.sunday.dayDefinitions.length);
                }
            }
        };

        return definition;
    }
]);